'use client';

import {
  Button,
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';
import Link from 'next/link';

import { ArticleCardProps } from '~components/ArticleCard/ArticleCard.types';
import { CardDraftLabel } from '~components/CardDraftLabel/CardDraftLabel';
import { NextImage } from '~components/NextImage/NextImage';
import { NextImageMods } from '~components/NextImage/NextImage.types';
import { getMonthDayDate } from '~helpers/date/getDate';
import { ArticleCardImagePosition } from '~types/Article.types';

import styles from './ArticleCard.module.scss';

export function ArticleCard({
  className,
  title,
  categories,
  publishedAt,
  image,
  href,
  imagePosition = ArticleCardImagePosition.Top,
  imageWithBg,
  onClick,
  mods,
}: ArticleCardProps) {
  return (
    <article
      className={classNames(
        className,
        styles.card,
        imagePosition === ArticleCardImagePosition.Bottom &&
          styles.imagePositionBottom,
        imageWithBg && styles.imageWithBg,
        mods?.map((mod) => styles[mod]),
      )}
    >
      {!publishedAt && <CardDraftLabel />}
      {image && (
        <div className={styles.media}>
          <NextImage
            className={styles.image}
            mods={!imageWithBg ? [NextImageMods.FitContain] : []}
            {...image}
          />
        </div>
      )}

      <div className={styles.content}>
        <div className={styles.top}>
          {!!categories?.length &&
            categories.map((category) => (
              <Typography
                tagName={TypographySizes.div}
                mods={[TypographyMods.bodySAlt]}
                key={category.id}
                className={styles.category}
              >
                {category.title}
              </Typography>
            ))}

          <Typography
            tagName={TypographySizes.div}
            mods={[TypographyMods.bodySAlt]}
            className={styles.date}
          >
            {getMonthDayDate(new Date(publishedAt))}
          </Typography>
          <Typography
            tagName={TypographySizes.h3}
            mods={[TypographyMods.titleL]}
            className={styles.title}
          >
            {title}
          </Typography>
        </div>
        <div className={styles.buttonContainer}>
          <Link href={href} onClick={onClick}>
            <Button
              className={styles.button}
              size="m"
              mod="tertiary"
              isSpan={true}
              text="Читать статью"
            />
          </Link>
        </div>
      </div>
    </article>
  );
}
